import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogComponent } from '@prekog/common-ui';
import { AddPackagepriceDialogResult } from './addpackagepricedialogresult';
import { AddPackagePriceRequest } from './addpackagepricerequest';

@Component({
    selector: 'app-addpackagepricedialog',
    templateUrl: './addpackagepricedialog.component.html',
    styleUrls: ['./addpackagepricedialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, ReactiveFormsModule]
})

export class AddpackagepriceDialogComponent extends DialogComponent {
    addPackagePriceRequest: AddPackagePriceRequest = {};
    packagePriceForm?: FormGroup;

    constructor(
        private _fb: FormBuilder
    ) {
        super();
        this.createPPackageForm();
    }

    createPPackageForm() {
        this.packagePriceForm = this._fb.group({
            packagePrice: ['', [Validators.required]]
        });
    }

    addPackagePrice() {
        const addPackagepriceDialogResult: AddPackagepriceDialogResult = {
            packagePrice: this.packagePriceForm?.controls['packagePrice'].value as number | undefined
        }
        this.accept(addPackagepriceDialogResult);
    }
}
